import { render, staticRenderFns } from "./UserTextRecommendations.vue?vue&type=template&id=b2a85db0&scoped=true"
import script from "./UserTextRecommendations.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTextRecommendations.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserTextRecommendations.vue?vue&type=style&index=0&id=b2a85db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a85db0",
  null
  
)

export default component.exports